import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../data/mock";

const ServicesTeaser = () => {
  return (
    <section className="py-24 md:py-32 bg-white relative overflow-hidden">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-neutral-100 border border-black/5 text-xs uppercase tracking-[0.2em] font-semibold text-neutral-700">
              <Icons.Layers size={14} className="text-pink-500" />
              Was wir machen
            </span>
            <h2 className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[1.02] mt-6 text-neutral-950">
              Vier Bausteine.{" "}
              <span className="bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 bg-clip-text text-transparent">
                Ein Ergebnis.
              </span>
            </h2>
          </div>
          <Link
            to="/leistungen"
            className="group inline-flex items-center gap-2 text-sm font-bold text-neutral-950 uppercase tracking-[0.12em] border-b-2 border-neutral-950 pb-1 hover:border-pink-500 hover:text-pink-500 transition-colors self-start md:self-end"
          >
            Alle Leistungen ansehen
            <ArrowRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <Link
                key={s.id}
                to="/leistungen"
                className="group relative p-7 rounded-3xl bg-neutral-50 hover:bg-neutral-950 border border-black/5 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-20px_rgba(0,0,0,0.25)]"
              >
                <div className="w-12 h-12 rounded-2xl bg-white border border-black/5 flex items-center justify-center group-hover:bg-gradient-to-br group-hover:from-pink-500 group-hover:via-orange-500 group-hover:to-purple-500 group-hover:border-transparent transition-all duration-500">
                  <Icon
                    size={22}
                    className="text-neutral-900 group-hover:text-white transition-colors duration-500"
                  />
                </div>
                <h3 className="mt-6 font-display font-extrabold text-xl tracking-tight text-neutral-950 group-hover:text-white transition-colors duration-500">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-neutral-600 group-hover:text-neutral-300 leading-relaxed transition-colors duration-500">
                  {s.subtitle}
                </p>
                <div className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-pink-500 group-hover:text-orange-300">
                  Mehr erfahren
                  <ArrowRight
                    size={14}
                    className="transition-transform duration-300 group-hover:translate-x-0.5"
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesTeaser;
